module.exports = __webpack_public_path__ + "static/media/food-truck-campus-events.d375ca71.jpg";